import { render, staticRenderFns } from "./awardList.vue?vue&type=template&id=a54dd512&scoped=true&"
import script from "./awardList.vue?vue&type=script&lang=js&"
export * from "./awardList.vue?vue&type=script&lang=js&"
import style0 from "./awardList.vue?vue&type=style&index=0&id=a54dd512&lang=scss&scoped=true&"
import style1 from "./awardList.vue?vue&type=style&index=1&id=a54dd512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54dd512",
  null
  
)

export default component.exports